import axiosPrivate from "@services/axiosPrivate"
import { FACEBOOK_THUMBNAIL_URL } from "src/constants"

export const getVideoThumbnailUrl = async (videoId) => {
   return axiosPrivate.get(`${videoId}/${FACEBOOK_THUMBNAIL_URL}`, {
      params: {
         fields:
            "id,uri,width,height",
      },
   })
}
